import * as yup from 'yup';

export const DeleteProfileFormValidation = yup
  .object({
    password: yup.string().required('Password is required'),
  });
